module.exports = __webpack_public_path__ + "assets/media/day40.91c9e4dc.mp3";